import React from 'react';
import { connect } from 'react-redux';
import { Container, CssBaseline } from '@material-ui/core';
import { hasAuthourity } from '../../lib/access.es6';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

import { hashHistory } from 'react-router';
import * as actions from '../Users/actions.es6';
import ProductsHeader from '../NewProductList/components/ProductsHeader/ProductsHeader';
import SkeletonWrapper from '../NewProductList/components/SkeletonWrapper/SkeletonWrapper';

import EnabledUsersTable from './UsersTable/EnabledUsersTable';
import DisabledUsersTable from './UsersTable/DisabledUsersTable';
import AddPartnerUser from './Component/AddPartnerUser';
import EditPartnerUser from './Component/EditPartnerUser';
import DisablePartnerUser from './Component/DisablePartnerUser';
import EnablePartnerUser from './Component/EnablePartnerUser';
import ResetPartnerUserPassword from './Component/ResetPartnerUserPassword';
import UsersAudit from '../UsersNew/UsersTable/UsersAudit';
import UserAudit from '../UsersNew/UsersTable/UserAudit';

function TabPanel(props) {
  var children = props.children;
  var value = props.value;
  var index = props.index;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={'partner-users-tabpanel-' + index}
      aria-labelledby={'partner-users-tab-' + index}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: 'partner-users-tab-' + index,
    'aria-controls': 'partner-users-tabpanel-' + index,
  };
}

export class PartnerUsers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openAddUserDialog: false,
      userToEditRoles: null,
      openViewAuditDialog: false,
      userToResetPassword: null,
      tabValue: 0,
    };
  }

  componentWillMount() {
    if (!hasAuthourity('VIEW_PARTNER_USERS')) {
      hashHistory.push('admin/home');
      return;
    }
    this.props.dispatch(actions.getUsersRequest());
    this.props.dispatch(actions.getRolesRequest());
    this.props.dispatch(actions.getDisabledUsersRequest());
  }

  closeAddUserDialog() {
    this.setState({ openAddUserDialog: false });
  }

  addUser(user) {
    this.props.dispatch(actions.createtUsersRequest(user));
  }

  refreshUsers() {
    this.props.dispatch(actions.getUsersRequest());
    this.props.dispatch(actions.getDisabledUsersRequest());
  }

  setUserToDisable(user) {
    this.props.dispatch(actions.setUserToDisable(user));
  }

  setUserToEnable(user) {
    this.props.dispatch(actions.setUserToEnable(user));
  }

  disableUser(user) {
    this.props.dispatch(actions.disableUserRequest(user.id));
  }

  enableUser(user) {
    this.props.dispatch(actions.enableUserRequest(user.id));
  }

  resetUserToDisable() {
    this.props.dispatch(actions.resetUserToDisable());
  }

  resetUserToEnable() {
    this.props.dispatch(actions.resetUserToEnable());
  }

  editUser(user) {
    this.props.dispatch(actions.updateRolesAndPartnersdRequest(user));
  }

  resetEditUserSuccess() {
    this.props.dispatch(actions.resetEditUserSuccess());
  }

  resetEditUserError() {
    this.props.dispatch(actions.resetEditUserError());
  }

  setUserToResetPassword(user) {
    this.props.dispatch(actions.clearResetPasswordState());
    this.setState({ userToResetPassword: user });
  }

  resetUserPassword(user) {
    this.props.dispatch(actions.resetPasswordRequest(user.id));
  }

  handleViewAudit(user) {
    this.props.dispatch(actions.setUserToViewAuthActivities(user));
    this.setState({ openViewAuditDialog: true });
  }

  closeViewAuditDialog() {
    this.setState({ openViewAuditDialog: false });
  }

  handleTabChange(event, newValue) {
    this.setState({ tabValue: newValue });
  }

  render() {
    var userData = this.props.userData;

    return (
      <>
        <CssBaseline />
        <Container maxWidth="lg" style={{ marginTop: '3%' }}>
          <SkeletonWrapper loading={userData.loader} />

          {!userData.loader && (
            <>
              <ProductsHeader
                title="User Administration"
                showAddButton={true}
                onAddButtonClick={() => { this.setState({ openAddUserDialog: true }); }}
                showEditButton={false}
                onEditButtonClick={() => {}}
              />

              <Tabs
                value={this.state.tabValue}
                onChange={this.handleTabChange.bind(this)}
                aria-label="Partner user administration tabs"
                sx={{ borderBottom: 1, borderColor: 'divider', width: '100%', marginBottom: '1%' }}
              >
                <Tab label="Active Users" {...a11yProps(0)} />
                <Tab label="Disabled Users" {...a11yProps(1)} />
                <Tab label="User Activity Audit" {...a11yProps(2)} />
              </Tabs>

              <TabPanel value={this.state.tabValue} index={0}>
                <EnabledUsersTable
                  users={userData.users || []}
                  loader={userData.loader}
                  setUserToEditRoles={(user) => { this.setState({ userToEditRoles: user }); }}
                  setUserToDisable={this.setUserToDisable.bind(this)}
                  handleViewAudit={this.handleViewAudit.bind(this)}
                  setUserToResetPassword={this.setUserToResetPassword.bind(this)}
                />
              </TabPanel>

              <TabPanel value={this.state.tabValue} index={1}>
                <DisabledUsersTable
                  users={userData.disabledUsers || []}
                  loader={userData.loader}
                  setUserToEnable={this.setUserToEnable.bind(this)}
                  handleViewAudit={this.handleViewAudit.bind(this)}
                />
              </TabPanel>

              <TabPanel value={this.state.tabValue} index={2}>
                <UsersAudit />
              </TabPanel>

              <UserAudit
                user={userData.userToViewAuthActivities}
                openViewAuditDialog={this.state.openViewAuditDialog}
                closeViewAuditDialog={this.closeViewAuditDialog.bind(this)}
              />

              <AddPartnerUser
                openAddUserDialog={this.state.openAddUserDialog}
                closeAddUserDialog={this.closeAddUserDialog.bind(this)}
                addUser={this.addUser.bind(this)}
                showAddUserProgressAlert={userData.createUserLoader}
                showAddUserSuccessAlert={userData.createUserSuccess}
                resetAddUserSuccessAlert={() => {
                  this.props.dispatch(actions.resetCreateUserSuccess());
                }}
                refreshUsers={this.refreshUsers.bind(this)}
                allRoles={userData.roles}
                showAddUserErrorAlert={!!userData.registrationError}
                addUserError={userData.registrationError}
                resetAddUserErrorAlert={() => {
                  this.props.dispatch(actions.createUsersFail(null));
                }}
              />

              <EditPartnerUser
                user={this.state.userToEditRoles}
                resetUserToEditRoles={() => { this.setState({ userToEditRoles: null }); }}
                editUser={this.editUser.bind(this)}
                showEditUserProgressAlert={userData.loader}
                showEditUserSuccessAlert={userData.editUserSuccess}
                showEditUserErrorAlert={!!userData.updateRolesAndPartnersErrors}
                editUserError={userData.updateRolesAndPartnersErrors}
                resetEditUserSuccessAlert={this.resetEditUserSuccess.bind(this)}
                resetEditUserErrorAlert={this.resetEditUserError.bind(this)}
              />

              <DisablePartnerUser
                user={userData.userToDisable}
                disableUser={this.disableUser.bind(this)}
                resetUserToDisable={this.resetUserToDisable.bind(this)}
                showDisableUserProgressAlert={userData.disableUserLoader}
                showDisableUserSuccessAlert={userData.disableUserSuccess}
                showDisableUserErrorAlert={!!userData.disableUserErrors}
                disableUserError={userData.disableUserErrors}
                resetDisableUserSuccessAlert={() => {
                  this.props.dispatch(actions.resetDisableUserSuccess());
                  this.refreshUsers();
                }}
                resetDisableUserErrorAlert={() => {
                  this.props.dispatch(actions.resetDisableUserError());
                }}
              />

              <ResetPartnerUserPassword
                user={this.state.userToResetPassword}
                resetPassword={this.resetUserPassword.bind(this)}
                resetUserToResetPassword={() => {
                  this.setState({ userToResetPassword: null });
                }}
                clearResetPasswordState={() => {
                  this.props.dispatch(actions.clearResetPasswordState());
                }}
                showProgressAlert={userData.resetPasswordLoader}
                showSuccessAlert={!!userData.resetPasswordSuccess}
                showErrorAlert={!!userData.resetPasswordErrors}
              />

              <EnablePartnerUser
                user={userData.userToEnable}
                enableUser={this.enableUser.bind(this)}
                resetUserToEnable={this.resetUserToEnable.bind(this)}
                showEnableUserProgressAlert={userData.enableUserLoader}
                showEnableUserSuccessAlert={userData.enableUserSuccess}
                showEnableUserErrorAlert={!!userData.enableUserErrors}
                enableUserError={userData.enableUserErrors}
                resetEnableUserSuccessAlert={() => {
                  this.props.dispatch(actions.resetEnableUserSuccess());
                  this.refreshUsers();
                }}
                resetEnableUserErrorAlert={() => {
                  this.props.dispatch(actions.resetEnableUserError());
                }}
              />
            </>
          )}
        </Container>
      </>
    );
  }
}

export default connect(function(state) {
  return {
    userData: state.userAdmin,
  };
})(PartnerUsers);
